/* src/app/private/components/leads/lead-call/lead-call.component.scss */
.invalid-phone-text {
  color: red;
  font-weight: 500;
  font-size: 11px;
  margin-top: 6px;
  margin-left: 5px;
}
/*# sourceMappingURL=lead-call.component.css.map */
